export default __webpack_public_path__ + "search.0b9bdc38.svg";